import {apolloSilent} from '@/graphql/apolloWrapper'
import {GET_ALL_UPDATES} from "../../graphql/queries/jobs/updates";

const state = {
  lastUpdate: '',
  updaters: {
    servers: 'serverFetchList',
    licenses: 'licenseFetchList',
    grab_stats: 'processActiveUpdate'
  }
};

const getters = {};

const mutations = {
  LAST_UPDATE_RENEW: function (state) {
    state.lastUpdate = (new Date()).toISOString().replace(/T/, ' ').replace(/\..+/, '');
  }

};

const actions = {
  async jobsFetchUpdates ({commit, dispatch, state}) {
    // console.log(state.lastUpdate)
    const {data} = await apolloSilent.query({query: GET_ALL_UPDATES, variables: {'since': state.lastUpdate}})

    if (data && data.commandJobList) {
      const jobs = data.commandJobList;
      let dataTypes = [];

      if (jobs.length) {
        // console.log(jobs)
        jobs.forEach(job => {
          let jobResponse = JSON.parse(job.response);
          if (jobResponse && jobResponse.message) {
            let actionName = (job.status === 3) ? 'addSuccessNotification' : 'addErrorNotification';
            dispatch(actionName, jobResponse.message);
          }
          if (job.data_affected) {
            dataTypes = dataTypes.concat(job.data_affected);
          }
        });
        dataTypes = [...new Set(dataTypes)];
        dispatch('jobsDispatchUpdates', dataTypes);
      }
      commit('LAST_UPDATE_RENEW')
    }
    // console.log(data);
  },
  jobsDispatchUpdates ({dispatch, state}, dataTypes) {
    if (dataTypes.length) {
      dataTypes.forEach(dataType => {
        if (state.updaters[dataType]) {
          dispatch(state.updaters[dataType]);
          // console.log('dispatching ' + state.updaters[dataType])
        }
      });
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/jobs.js